export default __webpack_public_path__ + "static/media/Briefcase_News_Business_Terms_and_Conditions_23_May_2019.7008b807.pdf";